export default function (props: any) {
    return (
        <svg width="0.6em" height="1em" viewBox="0 0 9 15" xmlns="http://www.w3.org/2000/svg">
            <g stroke="none" strokeWidth="1">
                <g transform="translate(-1212.000000, -661.000000)">
                    <g transform="translate(0.000000, 60.000000)">
                        <g transform="translate(1128.000000, 540.996536)">
                            <g transform="translate(84.000000, 58.999622)">
                                <path
                                    d="M8.08031662,3.93968804 L5.79402994,3.93968804 C5.64786767,3.93968804 5.51215129,4.02107734 5.3868808,4.18385593 C5.26159885,4.34662336 5.19896934,4.5399062 5.19896934,4.76372677 L5.19896934,6.4117819 L8.08031662,6.4117819 L7.67316748,8.73126525 L5.19896934,8.73126525 L5.19896934,15.6897365 L2.4742073,15.6897365 L2.4742073,8.73126525 L0,8.73126525 L0,6.4117819 L2.4742073,6.4117819 L2.4742073,5.0383989 C2.4742073,4.06177198 2.78738926,3.22248672 3.41377607,2.52053193 C4.04016289,1.81857715 4.83356939,1.46760534 5.79402994,1.46760534 L8.08031662,1.46760534 L8.08031662,3.93968804 Z"
                                    id="Fill-1"
                                ></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
